import { Component, ViewChild, ViewContainerRef } from '@angular/core';
import { IDoesFilterPassParams, IFilterOptionDef } from 'ag-grid-community';
import { FilterUIModel, FilterValueModel } from '../filterUI.model';
import { AgGridFilterBase, WSTextFilterParams } from '../agGridFilterBase';
import { AgGridFilterParams } from '../../agGridFilterParams';

@Component({
    selector: 'ws-ag-grid-yes-no-filter',
    templateUrl: '../Text/agGridTextFilter.component.html',
    styleUrls: ['../agGridFilters.scss'],
    standalone: false
})
export class AgGridYesNoFilterComponent extends AgGridFilterBase<WSTextFilterParams> {
    constructor() {
        super();
    }

    @ViewChild('applyButton', { read: ViewContainerRef }) applyButton;

    selectFilterOptions: IFilterOptionDef[] = [];
    filterOptions: Array<string | IFilterOptionDef> = [];
    filterConditionType: Core.FilterConditionTypeEnum = Core.FilterConditionTypeEnum.None;
    filterValues: FilterValueModel[] = [];
    maxHeight: string = '500px';

    agInit(params: WSTextFilterParams): void {
        this._params = params;
        this._valueGetter = params.getValue;
        this._filterValueGetter = params.colDef.filterValueGetter;

        this._searchTypeMap = new Map([
            ['', (fv, cv) => true],
            ['yes', (fv, cv) => cv && (cv.toLowerCase() === 'yes' || cv.toLowerCase() === 'true')],
            ['no', (fv, cv) => cv && (cv.toLowerCase() === 'no' || cv.toLowerCase() === 'false')],
            ['blank', (fv, cv) => !cv],
            ['notBlank', (fv, cv) => !!cv]
        ]);
        this._defaultFilterOptions = [
            AgGridFilterParams.noFilterOptionDef.displayKey,
            AgGridFilterParams.yesOptionDef.displayKey,
            AgGridFilterParams.noOptionDef.displayKey
        ];

        this.filterOptions = (params.filterOptions) ? params.filterOptions : this._defaultFilterOptions;
         
        this.selectFilterOptions = this.filterOptions.map(this._formatOption.bind(this));

        this.filterValues = [{ filterValue: '', filterType: this._getDefaultFilterType(this.selectFilterOptions) }];
    }

    isFilterActive(): boolean {
        return this.filterValues.some(x => x.filterType.displayKey !== AgGridFilterParams.noFilterOptionDef.displayKey);
    }

    doesFilterPass(params: IDoesFilterPassParams): boolean {
        if (!this.filterValues[0].filterType || this.filterValues[0].filterType === AgGridFilterParams.noFilterOptionDef) {
            return true;
        }
        const filterTest = (x: FilterValueModel) => {
            let value = '';
            if (this._filterValueGetter) {
                const filterParams = {
                    ...params,
                    getValue: this._valueGetter,
                    valueGetterParams: { ...this._params, ...params }
                } as any;
                value = (typeof this._filterValueGetter === 'string') ? this._filterValueGetter : this._filterValueGetter(filterParams);
            } else {
                value = this._valueGetter(params.node);
            }

            if (typeof value === 'boolean') {
                value = value ? 'yes' : 'no';
            }

            const cellValue = (value) ? value.toString().toLowerCase() : '';
            if (this._params.textCustomComparator) {
                return this._params.textCustomComparator(x.filterType.displayKey, cellValue, x.filterType.displayName, params.node.data);
            } else {
                return x.filterType.predicate([x.filterType.displayName], cellValue);
            }
        };
        return this.filterConditionType === Core.FilterConditionTypeEnum.Or
            ? this.filterValues.some(filterTest) : this.filterValues.every(filterTest);
    }

    getModel() {
        if (this.filterValues.length > 1) {
            this.filterValues = this.filterValues.some(x => x.filterType !== AgGridFilterParams.noFilterOptionDef)
                ? this.filterValues.filter(x => x.filterType !== AgGridFilterParams.noFilterOptionDef)
                : [{ filterValue: '', filterType: AgGridFilterParams.noFilterOptionDef }];
        }
        this.filterConditionType = this.filterValues.length > 1 ? this.filterConditionType : Core.FilterConditionTypeEnum.None;
        return (this.filterValues.length && this.filterValues.some(x => !!x.filterType.displayKey.trim()))
            ? {
                filterType: 'yesno',
                filterConditionType: this.filterConditionType,
                filterValues: this.filterValues
            }
            : null;
    }

    setModel(model: FilterUIModel): void {
        this._appliedModel = model;

        this.filterValues = [{ filterValue: '', filterType: this._getDefaultFilterType(this.selectFilterOptions) }];
        this.filterConditionType = model ? model.filterConditionType : Core.FilterConditionTypeEnum.None;
        if (!model) {
            return;
        }
        if (model && model.filterValues) {
            this.filterValues = model.filterValues.map(x => ({
                filterValue: x.filterValue,
                filterType: this.selectFilterOptions.find(y => y.displayKey === x.filterType.displayKey)
            }));
        }
    }
}
